import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { cloneDeep } from 'lodash';
import GenericButton from './GenericButton';

import * as definitionActions from '../../actions/definitionActions';

class AddToDefinition extends Component {
  constructor(props) {
    super(props);
    const { folderName } = props;

    let definitionList = [];

    if (props.srcScreen === 'DefinitionScreen' && props.definitionList.data) {
      definitionList = props.definitionList.data;
    }
    this.state = {
      definitionList,
      folderName,
      activetarget: 'newDefinition',
    };

    if (
      props.srcScreen !== 'DefinitionScreen' &&
      this.props.loginResponse &&
      this.props.activeAccountId &&
      this.props.moduleStudy
    ) {
      this.props.definitionActions.getDefinitionTreeLoad(
        this.props.loginResponse.data.token,
        this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.definitionList !== nextProps.definitionList &&
      nextProps.definitionList &&
      nextProps.definitionList.status === 'SUCCESS'
    ) {
      this.setState({ definitionList: [...nextProps.definitionList.data] });
    }
  }

  activeTarget = e => this.setState({ activetarget: e.target.value });

  patchDefinition = selectedDefinition => {
    const modifiedExp = cloneDeep(this.props.newExpressions);
      modifiedExp.forEach((item) => {
      item.expression = item.expression.replaceAll('\t', '');
      });
    const patchDefinition = {
      token: this.props.loginResponse.data.token,
      ssid: this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      accountId: this.props.activeAccountId,
      productNo: this.props.moduleStudy.pn,
      newExpressions: modifiedExp,
      // refreshDefinitions: this.props.srcScreen === 'DefinitionScreen',
    };
    if (this.state.activetarget === 'existingDefinition') {
      patchDefinition.definitionId = selectedDefinition;
      this.props.definitionActions.patchTargetFolder(patchDefinition);
    } else {
      patchDefinition.folderName = this.newDefinitionFolder.value;
      patchDefinition.thisStudy = false;
      patchDefinition.shared = false;
      this.props.definitionActions.createNewDefinition(patchDefinition);
    }
  };

  renderDropdownData = () =>
    this.state.definitionList
      .filter(definition => definition.scope === 4 || definition.scope === 5)
      .map(({ folderName, definitionId }) => (
        <option value={definitionId} key={definitionId}>
          {folderName}
        </option>
      ));

  render() {
    return (
      <div>
        <form>
          <div className="row expanded">
            <div className="small-12 columns">
              <p>Add selected Targets to...</p>
            </div>
            <div className="small-6 medium-5 large-5 columns">
              <label htmlFor="newDefinition">
                <input
                  id="newDefinition"
                  type="radio"
                  name="radioDefinition"
                  value="newDefinition"
                  checked={this.state.activetarget === 'newDefinition'}
                  onChange={this.activeTarget}
                />
                <span>New Definition</span>
              </label>
            </div>
            <div className="small-6 medium-7 large-7 columns padding-right-0">
              <input
                disabled={this.state.activetarget !== 'newDefinition'}
                type="text"
                defaultValue={this.state.folderName}
                id="right-label"
                placeholder="Inline Text Input"
                ref={node => (this.newDefinitionFolder = node)}
              />
            </div>
            <div className="small-6 medium-5 large-5 columns">
              <label htmlFor="existingDefinition">
                <input
                  id="existingDefinition"
                  type="radio"
                  name="radioDefinition"
                  value="existingDefinition"
                  checked={this.state.activetarget !== 'newDefinition'}
                  onClick={this.activeTarget}
                />
                <span>Existing Definition</span>
              </label>
            </div>
            <div className="small-6 medium-7 large-7 columns margin-top-10 margin-bottom-10 padding-right-0">
              <select
                ref={node => (this.selectedDefinitionOption = node)}
                disabled={this.state.activetarget === 'newDefinition'}
                className={
                  this.state.activetarget === 'newDefinition'
                    ? 'existing-def-disabled'
                    : ''
                }
                style={{ height: '63px' }}
              >
                {this.renderDropdownData()}
              </select>
            </div>
            <div className="small-12 button-group text-right margin-top-15 clearfix">
              <GenericButton
                name="Ok"
                btnStyle="button"
                onBtnClick={() => {
                  this.patchDefinition(this.selectedDefinitionOption.value);
                  this.props.handleHide();
                }}
              />
              <GenericButton
                name="Cancel"
                btnStyle="button btn-cncl"
                onBtnClick={() => this.props.handleHide()}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

AddToDefinition.propTypes = {
  folderName: PropTypes.string,
  handleHide: PropTypes.func,
  srcScreen: PropTypes.string,
  newExpressions: PropTypes.arrayOf(PropTypes.shape({})),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
    status: PropTypes.number,
  }),
  activeAccountId: PropTypes.number,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    ss: PropTypes.string,
  }),
  definitionList: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    status: PropTypes.number,
  }),
  definitionActions: PropTypes.shape({
    getDefinitionTreeLoad: PropTypes.func,
    patchTargetFolder: PropTypes.func,
    createNewDefinition: PropTypes.func,
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    definitionList: state.definition.definitionTree,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    definitionActions: bindActionCreators(definitionActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddToDefinition);
